import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { getBeltScaleData } from '@/service/beltScaleData';
export default function useProductionData(params) {
  var beltScaleData = ref({
    list: []
  });
  // 获取皮带秤数据
  var getBeltScaleDataAsync = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getBeltScaleData(params.value);
          case 2:
            data = _context.sent;
            beltScaleData.value = data;
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function getBeltScaleDataAsync() {
      return _ref.apply(this, arguments);
    };
  }();
  return [beltScaleData, getBeltScaleDataAsync];
}